export default "__VITE_ASSET__97834957__"